export interface GiftCard {
  type: GiftCardType;
  value: number;
  recipientName: string;
  recipientEmail: string;
  accompanyingMessage: string;
  charges?: number;
  chargesAmount?: number;
}

export enum GiftCardType {
  Gift,
  Punch,
}
